import React, { FC } from "react";
import { Button, Col } from "antd";
import styled from "styled-components";
import { prettyMoney } from "../../helpers";
import { CatalogItemVariation } from "../../queries/auto-generated/schemas";

const Variation: FC<{
  selected: boolean;
  toggleSelected: Function;
  variation: CatalogItemVariation;
}> = ({ selected, toggleSelected, variation }) => {
  const amount = variation?.price_money?.amount;
  const currency = variation?.price_money?.currency;

  return (
    <Col span={8} xs={24} sm={24} md={8} lg={8} xl={8}>
      <StyledButton
        type={selected ? "primary" : "default"}
        onClick={(e) => {
          e.stopPropagation();
          toggleSelected();
        }}
      >
        <VariationName>{variation?.name}</VariationName>
        <div>{amount && currency && prettyMoney(amount, currency)}</div>
      </StyledButton>
    </Col>
  );
};

const VariationName = styled.div`
  font-weight: bold;
  white-space: break-spaces;
`;
const StyledButton = styled(Button)`
  width: 100%;
  height: 100%;
  padding: 1em;
`;

export default Variation;
